<style scoped lang="sass">
.title
  font-weight: 700
  margin-bottom: 0.5rem
form
  margin: 0
  padding: 0
  box-shadow: none
  .suggestions
    overflow: auto
    max-height: 6rem
    .suggestion
      display: flex
      justify-content: space-between
      align-items: center
      margin-bottom: 0.25rem
      .name
        margin-right: 0.5rem
      .button
        margin-top: 0
        font-size: 0.8rem
        padding: 0.25rem 0.5rem
</style>
<template>
<div>
  <pinhigh-modal :on-close="onClose">
    <div class="title">Invite Your Friends</div>
    <form @submit.prevent="submit">
      <div class="input-group">
        <label>SEARCH</label>
        <input type="text" v-model="search" placeholder="Type name or email" class="input-control">
      </div>
      <div class="suggestions">
        <div v-for="({name, email}) in contacts" class="suggestion">
          <span class="name ellipsis-overflow">{{suggestionDisplayName({name,email})}}</span>
          <button @click.prevent="addParticipation({email})" class="button positive inline">Add</button>
        </div>
      </div>
    </form>
  </pinhigh-modal>
</div>
</template>
<script>
import api from '../api';

export default {
  name: 'InviteFriends',
  props: {
    pool: {
      type: Object,
      required: true
    },
    onClose: {
      type: Function,
      required: true
    }
  },
  data() {
    return {
      search: '',
      contacts: [],
      errors: []
    };
  },
  computed: {
  },
  methods: {
    addParticipation({email}) {
      api.PoolParticipationOffer.create({params: {id: this.pool.id, participation_offer: {email}}})
        .then(() => {
          this.$store.dispatch('updateCachedPool', {params: {id: this.pool.id}});
          this.onClose();
        })
        .catch(err => {
          this.errors = err.response.data.errors;
        });
    },
    suggestionDisplayName({name,email}) {
      if (name) {
        return `${name} (${email})`;
      } else {
        return email;
      }
    }
  },
  watch: {
    search: _.debounce(function(value) {
      Promise.all([
        // Suggest past participants
        new Promise(resolve => {
          if (value && value.length > 1) {
            api.ParticipationSuggestion.index({params: {search: value}})
              .then(suggestions => resolve(suggestions));
          } else {
            resolve([]);
          }
        }),
        // If the search is an email address
        new Promise(resolve => {
          if (value.match(/^[a-zA-Z0-9_.+\-]+@[a-zA-Z0-9\-]+\.[a-zA-Z0-9\-.]+$/)) {
            resolve([{email: value}]);
          } else {
            resolve([]);
          }
        }),
        // Retrieve contact emails
        new Promise((resolve, reject) => {
          if (navigator.contacts) {
            navigator.contacts.find(
              [navigator.contacts.fieldType.displayName, navigator.contacts.fieldType.name, navigator.contacts.fieldType.emails],
              contacts => {
                resolve(
                  contacts
                    .filter(({emails}) => emails.length)
                    .reduce((memo, {name: {formatted: name}, emails}) => {
                      emails.forEach(({value: email}) => memo.push({name, email}));
                      return memo;
                    }, [])
                );
              },
              error => resolve([]),
              {filter: value, desiredFields: [navigator.contacts.fieldType.name, navigator.contacts.fieldType.emails]}
            );
          } else {
            resolve([]);
          }
        })
      ]).then(contactGroups => {
        this.contacts = [].concat(...contactGroups);
      });
    }, 300)
  }
};
</script>
